<template>
  <div class="search__content">
    <div class="search__sidebar">
      <div class="section">
        <div class="searchbar">
          <input
            type="search"
            class="searchbar__input"
            v-model="searchQuery"
            :placeholder="resource('searchInCatalog')"
          >
          <icon
            name="search"
            class="searchbar__icon"
          />
        </div>
      </div>
      <div class="section">
        <div class="section__title">{{resource('filterOn')}}</div>
        <select
          class="filter"
          @change="search"
          v-model="selectedfilter"
        >
          <option value>{{resource('category')}}</option>
          <option
            v-for="(filter, index) in category"
            :value="[index, filter.content[lang].name, filter.id]"
            :key="filter.content[lang].id"
          >{{filter.content[lang].name}}</option>
        </select>
        <select
          class="filter"
          @change="search"
          v-model="selectedsubfilter"
        >
          <option value>{{resource('subCategory')}}</option>
          <option
            v-for="(filter, index) in subCategory"
            :value="[index, filter.content[lang].name, filter.id]"
            :key="filter.content[lang].id"
          >{{filter.content[lang].name}}</option>
        </select>
        <select
          class="filter"
          @change="search"
          v-model="selectedbrand"
        >
          <option value>{{resource('brand')}}</option>
          <option
            v-for="(filter, index) in brands"
            :value="[index, filter.content[lang].name, filter.id]"
            :key="filter.content[lang].id"
          >{{filter.content[lang].name}}</option>
        </select>
      </div>
    </div>
    <div class="search__content">

      <transition name="fade">
        <div
          class="results__header result"
          v-if="results.length"
        >
          <div class="result__img"></div>
          <div class="result__title">{{resource('title')}}</div>
          <div class="result__ean">{{resource('ean')}}</div>
          <div class="result__brand">{{resource('brand')}}</div>
          <div class="result__orderQuantity">{{resource('orderQuantity')}}</div>
          <div class="result__price">{{resource('pricePerPiece')}}</div>
          <div class="result__amount">{{resource('amount')}}</div>
          <div class="result__add"></div>
        </div>
      </transition>
      <transition name="fade">

        <DynamicScroller
          :items="results"
          :min-item-size="93"
          class="search__results results"
          key-field="id"
          v-if="showList"
        >

          <template v-slot="{ item, index, active }">
            <DynamicScrollerItem
              :item="item"
              :active="active"
              :data-index="index"
            >
              <catalogProduct
                v-model="item"
                @add="addProduct($event)"
              />
            </DynamicScrollerItem>
          </template>

        </DynamicScroller>

      </transition>
      <transition name="fade">
        <div
          class="search__results search__results--none"
          v-if="!results.length"
        >{{resource('noResults')}}</div>
      </transition>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import catalogProduct from '@/components/app-catalogProduct.vue'

export default {
	name: 'offlineSearch',
	components: {
		catalogProduct
	},
	computed: {
		lang () {
			return this.$store.getters.language
		},
		category () {
			return this.orderAlphabetic(this.$store.state.categories)
		},
		subCategory () {
			return this.orderAlphabetic(this.$store.state.subCategories)
		},
		subSubCategory () {
			return this.orderAlphabetic(this.$store.state.subSubCategories)
		},
		subSubSubCategory () {
			return this.orderAlphabetic(this.$store.state.subSubSubCategories)
		},
		brands () {
			return this.orderAlphabetic(this.$store.state.brands)
		},
		subBrands () {
			return this.orderAlphabetic(this.$store.state.subBrands)
		}
	},
	data () {
		return {
			showList: true,
			searchTimeout: null,
			searchQuery: '',
			results: [],
			selectedbrand: '',
			selectedsubbrand: '',
			selectedfilter: '',
			selectedsubfilter: '',
			selectedsubsubfilter: '',
			selectedsubsubsubfilter: '',
			res: {
				nl: {
					search: 'Zoeken',
					filterOn: 'Filter op',
					searchInCatalog: 'Zoeken in catalogus',
					category: 'Categorie',
					subCategory: 'Subcategorie',
					subSubCategory: 'Subsubcategorie',
					subSubSubCategory: 'Subsubsubcategorie',
					title: 'Titel',
					ean: 'EAN',
					brand: 'Merk',
					subBrand: 'Submerk',
					orderQuantity: 'BE',
					pricePerPiece: 'Prijs p/s',
					amount: 'Aantal',
					total: 'Totaal',
					noResults: 'Geen resultaat',
					resetFilters: 'Wis filters'
				},
				fr: {
					search: 'Recherche',
					filterOn: 'Filtrer sur',
					searchInCatalog: 'Rechercher dans le catalogue',
					category: 'Catégorie',
					subCategory: 'sous-catégorie',
					subSubCategory: 'sous-sous-catégorie',
					subSubSubCategory: 'sous-sous-sous-catégorie',
					title: 'Titre',
					ean: 'EAN',
					brand: 'Marque',
					subBrand: 'Sous-marque',
					orderQuantity: 'OQ',
					pricePerPiece: 'Price p / p',
					amount: 'Nombre',
					total: 'Total',
					noResults: 'Aucun résultat',
					resetFilters: 'Effacer les filtres'
				}
			}
		}
	},
	watch: {
		results () {
			this.showList = false
			this.$nextTick(() => {
				this.showList = true
			})
		},
		searchQuery (newVal) {
			clearTimeout(this.searchTimeout)
			let $this = this
			this.searchTimeout = setTimeout(() => {
				$this.search()
			}, 500)
		},
		selectedfilter (newVal) {
			if (typeof newVal === 'object') {
				this.results = this.filterResults(
					this.results,
					newVal[2],
					'categoryId'
				)
			}
		},
		selectedsubfilter (newVal) {
			if (typeof newVal === 'object') {
				this.results = this.filterResults(
					this.results,
					newVal[2],
					'subCategoryId'
				)
			}
		},
		selectedsubsubfilter (newVal) {
			if (typeof newVal === 'object') {
				this.results = this.filterResults(
					this.results,
					newVal[2],
					'subSubCategoryId'
				)
			}
		},
		selectedsubsubsubfilter (newVal) {
			if (typeof newVal === 'object') {
				this.results = this.filterResults(
					this.results,
					newVal[2],
					'subSubSubCategoryId'
				)
			}
		},
		selectedbrand (newVal) {
			if (typeof newVal === 'object') {
				this.results = this.filterResults(
					this.results,
					newVal[2],
					'brandId'
				)
			}
		},
		selectedsubbrand (newVal) {
			if (typeof newVal === 'object') {
				this.results = this.filterResults(
					this.results,
					newVal[2],
					'subBrandId'
				)
			}
		}
	},
	methods: {
		resource (item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		orderAlphabetic (input) {
			if (input) {
				var lang = this.$store.getters.language
				var result = input.sort(function (a, b) {
					var textA = a.content[lang].name.toUpperCase()
					var textB = b.content[lang].name.toUpperCase()
					return textA < textB ? -1 : textA > textB ? 1 : 0
				})
				return result
			}
		},
		search () {
			this.expandend = {}
			var lang = this.$store.getters.language
			var allProducts = this.$store.state.products
			var searchQuery = this.searchQuery
			var options = {
				shouldSort: true,
				threshold: 0.3,
				location: 0,
				distance: 100,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					'content.' + lang + '.name',
					'content.' + lang + '.brand',
					'content.' + lang + '.subBrand',
					'ean'
				]
			}
			var fuse = new Fuse(allProducts, options) // "list" is the item array

			this.results = fuse.search(searchQuery)
		},
		filterResults (list, filter, type) {
			return list.filter(function (item) {
				return item[type] === filter
			})
		},
		resetFilters () {
			this.selectedbrand = ''
			this.selectedsubbrand = ''
			this.selectedfilter = ''
			this.selectedsubfilter = ''
			this.selectedsubsubfilter = ''
			this.selectedsubsubsubfilter = ''
			this.search()
		},
		close () {
			this.$emit('closeSearch')
		},
		addProduct (data) {
			this.$emit('addProduct', data)
		}
	}
}
</script>

<style lang="scss">
.search {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  select {
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    padding: $component;
    border: 1px solid $catalog__form-border;
    font-size: $fs-1;
  }
  &__container {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }
  &__sidebar {
    padding: $content;
    background: $catalog__sidebar-bg;
    border-bottom: 1px solid $catalog__border;
    flex: 0 0 auto;
    box-sizing: border-box;
    display: flex;
  }
  &__title {
    color: #fff;
  }
  &__content {
    flex: 1 1 auto;
    margin: $content;
    background: #fff;
    overflow: hidden;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
  }
  &__bar {
    padding: $content;
    background: $gray;
    display: flex;
    input {
      flex: 1 1 auto;
      height: 40px;
      padding: 0 $content;
      box-sizing: border-box;
    }
  }
  &__results {
    overflow: auto;
    &--none {
      min-height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $h1;
      text-transform: uppercase;
    }
  }
}
.searchbar {
  display: flex;
  border: 1px solid $catalog__form-border;
  padding-right: $content;
  flex: 1 1 auto;
  &__input {
    border: none;
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    padding: $component;
  }
}
.filter {
  text-transform: uppercase;
  + .filter {
    margin-left: $component;
  }
}
.results {
  flex: 1 1 auto;
  &__header {
    background: $catalog__header-bg;
    color: $catalog__header-color;
    flex: 0 0 auto;
    .result__img {
      height: auto;
    }
  }
}
.result {
  padding: $component;
  border-bottom: 1px solid $gray;
  position: relative;
  display: grid;
  align-items: center;
  grid-template-columns: 35px 70px auto 115px 120px 50px 70px 130px 60px;
  grid-template-areas: "expand image title ean brand orderQuantity price amount add";
  box-sizing: border-box;
  &__expandToggle {
    grid-area: expand;
  }
  &__img {
    grid-area: image;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__title {
    grid-area: title;
    padding: 0 $component 0 0;
  }
  &__ean {
    grid-area: ean;
    padding: 0 $component;
  }
  &__brand {
    grid-area: brand;
    padding: 0 $component;
  }
  &__orderQuantity {
    grid-area: orderQuantity;
  }
  &__price {
    grid-area: price;
  }
  &__amount {
    grid-area: amount;
  }
  &__add {
    grid-area: add;
    justify-self: flex-end;
  }
}
.section {
  display: flex;
  align-items: center;
  flex: 1 0 auto;
  & + & {
    margin-left: $container;
  }
  &__title {
    font-size: $fs1;
    text-transform: uppercase;
    display: flex;
    white-space: nowrap;
    margin-right: $component;
  }
}
</style>
